import { mapCustomFieldToOption } from './buildActiveCustomFieldOptions'
import {
  type SourceMappingBuildContext,
  type SourceMappingOptionGroup,
} from '../types'

export const buildInactiveCustomFieldOptions = (
  context: SourceMappingBuildContext
): SourceMappingOptionGroup | null => {
  const { customFields, translatedLabels } = context

  const activeFields = customFields.filter((cf) => !cf.active)

  if (activeFields.length === 0) {
    return null
  }

  return {
    label: translatedLabels.inactiveFieldsGroupLabel,
    options: activeFields.map(mapCustomFieldToOption),
  }
}
